import { doc } from "prettier";

export const changeBg = () => {
  window.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".js-pillars") == undefined || document.querySelector(".js-pillars") == null) {
      return;
    }

    const pillars = document.querySelectorAll(".js-pillars");

    function changeBackground() {
      console.log(pillars);
      pillars.forEach((item) => {
        item.classList.remove("is-active");
      });
    }

    pillars.forEach((item) => {
      item.addEventListener("mouseenter", (e) => {
        changeBackground();
        e.target.classList.add("is-active");
        // console.log(e.target);
      });
    });
  });
};
